import { AsyncPipe, NgIf } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { UIKitModule, VaSearchBoxModule } from '@vendasta/uikit';
import { combineLatest, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ActivatableItem, SelectedItem, SortDirection } from '../../../activation/core/interface';
import { ActivateAppTableService } from './activate-app-table.service';
import { ActivationTableComponent } from './app-activation-table';
import { PaginatedAppActivationTableService } from './paginated-app-activation-table.service';

@Component({
  standalone: true,
  imports: [
    AsyncPipe,
    NgIf,
    VaSearchBoxModule,
    TranslateModule,
    ActivationTableComponent,
    MatPaginatorModule,
    UIKitModule,
    RouterLink,
  ],
  selector: 'app-paginated-app-activation-table',
  templateUrl: './paginated-app-activation-table.component.html',
  styleUrls: ['./paginated-app-activation-table.component.scss'],
  providers: [ActivateAppTableService],
})
export class PaginatedAppActivationTableComponent implements OnInit {
  @Input() includeActiveAccounts: boolean;
  @Input() features: any = [];

  activatableItems$: Observable<ActivatableItem[]>;
  totalItems$: Observable<number>;
  hasUnavailableItems$: Observable<boolean>;
  pageOptions$: Observable<number[]>;
  showingRestrictedProducts$: Observable<boolean>;
  hidePricing$: Observable<boolean>;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private tableService: ActivateAppTableService) {}

  ngOnInit(): void {
    this.activatableItems$ = combineLatest([
      this.tableService.activatableItems$,
      this.tableService.activations$.pipe(startWith([])),
    ]).pipe(map(PaginatedAppActivationTableService.expandActiveProducts));

    this.totalItems$ = this.tableService.totalItems$;
    this.hasUnavailableItems$ = this.tableService.areItemsUnavailable$;
    this.pageOptions$ = this.tableService.pageOptions$;
    this.showingRestrictedProducts$ = this.tableService.showingRestrictedProducts$;
  }

  onProductPage(pageEvent: PageEvent): void {
    this.tableService.setPage(pageEvent);
  }

  onProductSearchTermChanged(term: string): void {
    this.tableService.setSearchTerm(term);
    // Fix for searching on a page other than the first page
    this.paginator.firstPage();
  }

  onProductSortOrderChanged(order: SortDirection): void {
    this.tableService.sortByName(order);
  }

  onItemSelected(selectedItem: SelectedItem): void {
    this.tableService.selectItem(selectedItem);
  }

  toggleRestrictedItems(): void {
    this.tableService.toggleShowingRestricted();
  }
}
